import React, { FC, memo } from 'react'
import multiPersonMobx from '@mobx/cashier/multiPerson.mobx'
import './index.scss'

// props
interface IProps {
  userKey: string;
}

const PersonAvatar: FC<IProps> = ({ userKey }) => {
  const user = multiPersonMobx.multiPersonMap[userKey] || {
    avatar: '',
    nickName: userKey === 'waiter' ? 'W' : 'G'
  }

  const nickName = user.nickName || 'G'

  return (
    <span className='cps-avatar'>
      {
        userKey === 'waiter' ? (<i className='iconfont icon-waiter'></i>) : user.avatar ? <img src={user.avatar} alt='' /> : nickName.substr(0, 1)
      }
    </span>
  )
}
export default memo(PersonAvatar)
